module.exports = __webpack_public_path__ + "static/media/blur bk.928878c2.jpg";